import { render, staticRenderFns } from "./model-address.vue?vue&type=template&id=386479f5&scoped=true&"
import script from "./model-address.vue?vue&type=script&lang=js&"
export * from "./model-address.vue?vue&type=script&lang=js&"
import style0 from "./model-address.vue?vue&type=style&index=0&id=386479f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386479f5",
  null
  
)

export default component.exports